export default __webpack_public_path__ + "static/media/dislikeActive.0dd9cabe.svg";